$(document).on('click', '.accordion__trigger', function (event) {
  let accordionItem = $(this).closest('.accordion__item');
  if (accordionItem.hasClass('open') == false) {
    accordionItem.addClass('open');
    accordionItem.find('.accordion__content').slideToggle(400);
  } else {
    accordionItem.removeClass('open');
    accordionItem.find('.accordion__content').slideToggle(400);
  }
});

const accordionTrigger = document.querySelectorAll('.accordion__trigger');
accordionTrigger.forEach((trigger, index) => {
  trigger.addEventListener('click', () => {
    accordionTrigger.forEach((innerTrigger, innerIndex) => {
      if (innerTrigger.parentNode.classList.contains('open') && index != innerIndex) {
        innerTrigger.click();
      }
    })
  })
});